const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const GainMPEvent = require('../../events/GainMPEvent');
const { logError } = require('../../logger');

const SendMana = function(battleState) {
  this.handle = 'send_mana';
  this.magic = true;
  this.ranged = true;
  this.help = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = function(actor, victim) {
    return victim && victim.unit;
  };

  this.execute = function(actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit&&!victim.inPlay)) {
      return { success: false };
    }

    try {
      var finalPotency = Math.floor(BattleCalc.getEquippedAbility(actor,this.handle).potency);
      if (finalPotency > victim.max_mp - victim.mp) {
        finalPotency = victim.max_mp - victim.mp;
      }

      const gainMP = new GainMPEvent(battleState, finalPotency);
      gainMP.execute(victim);
      gainMP.actorId = victim.uid;
      gainMP.victimId = victim.uid;

      var result = { gainMP };
      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.victimId = victim? victim.uid : null;
      result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'SendMana',
        func: 'execute',
        actor,
        victim,
      });
      return { success: false };
    }
  };
};
module.exports = SendMana;
